import { GalleryItem } from "./types";

export const galleryItems: GalleryItem[] = [
  {
    id: "riding-bikes",
    type: "video",
    src: "/videos/riding-bikes-at-street-lawyer-services.mp4",
    poster: "/videos/riding-bikes-at-street-lawyer-services.jpg",
    alt: "Riding bikes at Street Lawyer Services cannabis event",
  },
  {
    id: "bunny-model",
    type: "video",
    src: "/videos/street-lawyer-services-420-buny-model.mp4",
    poster: "/videos/street-lawyer-services-420-buny-model-poster.jpg",
    posterWebp: "/videos/street-lawyer-services-420-buny-model-poster.webp",
    alt: "Street Lawyer Services 420 bunny model event",
  },
  {
    id: "lonny-dancing",
    type: "video",
    src: "/videos/lonny-the-street-lawyer-dance-at-sls-dispenary-baltimore-maryland.mp4",
    poster:
      "/videos/lonny-the-street-lawyer-dance-at-sls-dispenary-baltimore-maryland-poster.jpg",
    posterWebp:
      "/videos/lonny-the-street-lawyer-dance-at-sls-dispenary-baltimore-maryland-poster.webp",
    alt: "Lonny the Street Lawyer dancing at SLS dispensary Baltimore Maryland",
  },
  {
    id: "sls-swag",
    type: "image",
    src: "/images/street-lawyer-services-swag.jpg",
    alt: "Street Lawyer Services Branded Merchandise and Swag",
  },
  {
    id: "models-at-sls",
    type: "video",
    src: "/videos/models-at-street-lawyer-services.mp4",
    poster: "/videos/models-at-street-lawyer-services.jpg",
    alt: "Models at Street Lawyer Services events",
  },
  // Adding a few more image items to ensure we have enough content
  {
    id: "cannabis-products",
    type: "image",
    src: "/images/weed-jar-and-street-lawyer-services-logo.jpg",
    alt: "Premium cannabis products at Street Lawyer Services",
  },
  {
    id: "dispensary-interior",
    type: "image",
    src: "/images/weed-joints-with-kief.jpg",
    alt: "Weed jar with kief",
  },
  {
    id: "grinder",
    type: "image",
    src: "/images/street-lawyer-services-grinder.jpg",
    alt: "Street Lawyer Services grinder",
  },
];
